module.exports = [{"type":"title","text":"2024-11-08"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"现货：账户信息推送，新增订阅后立即推送一次当前账户的概览,type=INIT"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/changelog/2024-11-08.json
// module id = htuQ
// module chunks = 3